import log from "loglevel"

export enum Environment {
    LOCAL_DEV = "LOCAL_DEV",
    DEV = "DEV",
    TEST = "TEST",
    PROD = "PROD",
}

const findCurrentEnv = () => {
    const hostname = window.location.hostname
    if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
        log.info("ENV: Local Dev")
        return Environment.LOCAL_DEV
    }
    // URL will include "nexus.nv5geospatial.com" by convention
    const envEndIndex = hostname.indexOf("nexus.nv5geospatial.com")
    if (envEndIndex === -1) {
        throw new Error(
            `While determining environment, couldn't find index for nexus.nv5geospatial.com in the current hostname: ${hostname}`,
        )
    }
    if (envEndIndex === 0) {
        // No Environment in the hostname implies prod
        return Environment.PROD
    }
    // Find the name of the environment
    const envName = hostname.slice(0, envEndIndex - 1)
    if (envName === "dev" || envName === "dev2") {
        log.info("ENV: Dev")
        return Environment.DEV
    }
    if (envName === "test") {
        log.info("ENV: Test")
        return Environment.TEST
    }
    throw new Error(
        `While determining environment, encountered an unexpected value for environment in hostname: ${envName}`,
    )
}

export const currentEnv = findCurrentEnv()
